import { sessaoFetchLoading } from '@/service/fetch'

export async function buscarEndpoint (payload) {
  return sessaoFetchLoading(`consig`, `/featuretoggle/BuscarEndpoint`, 'PATCH', payload)
}



// WEBPACK FOOTER //
// ./src/api/feature_toggle.js